
import EditorList from 'Editors/EditorList'
import EditorTipTap from 'Editors/EditorTipTap'

export default {
  components: {
    EditorList,
    EditorTipTap,
  },
  data() {
    return {
      options: [
        {
          name: 'title',
          label: 'Title',
          type: 'text',
        },
        {
          name: 'description',
          label: 'Description',
          type: 'text',
        },
        {
          name: 'image',
          label: 'PDF image preview',
          type: 'image',
        },
        {
          name: 'logo',
          label: this.$t('listLabels.pdf'),
          type: 'image',
        },
      ],
    }
  },
}
